import React, { useState, useEffect, useRef } from "react";
import {
  SubNavWrapper,
  SubNavList,
  SubNavListItem,
  NavListIconWrapper,
  NavListIcon,
  SubNavListText,
  SubNavListHeading,
  SubNavListDesc,
  Separator,
  SubHeading,
  PageLinkWrapper,
  PageLink,
} from "./styled";
import Link from "../common3/Link";

const SubNav = ({ navItem, theme, hovered, index }) => {
  const [width] = useState(400);
  const [left, setLeft] = useState();
  const ref = useRef();

  useEffect(() => {
    const parentWidth = ref.current.parentElement.offsetWidth;
    setLeft(parentWidth / 2 - width / 2);
  }, [width]);

  useEffect(() => {
    if (hovered === index) {
      const DOMRect = ref.current.getBoundingClientRect();

      const DOMLeft = DOMRect.left;
      if (DOMLeft < 0) {
        const offset = Math.abs(DOMLeft);
        setLeft((left) => left + offset + 5);
        return;
      }

      const DOMRight = DOMRect.right;
      const windowWidth = window.innerWidth;
      if (DOMRight > windowWidth) {
        const offset = DOMRight - windowWidth;
        setLeft((left) => left - offset - 5);
      }
    }
  }, [hovered, index]);

  return (
    <SubNavWrapper>
      <SubNavList
        bgColor={theme.dropdownBackground}
        ref={ref}
        width={width}
        left={left}
      >
        {navItem.sub.map((sub, i) => {
          if (sub.type === "navLink") {
            return (
              // Wrap with router link to sub.url
              <Link
                to={sub.url}
                className="sp-navlink"
                key={`sub-nav-item-${i}`}
              >
                <SubNavListItem
                  key={i}
                  iconColor={theme.dropdownIconColor}
                  hoverColor={theme.dropdownHoverColor}
                >
                  {sub.icon && (
                    <NavListIconWrapper bgColor={theme.dropdownNavItemColor}>
                      <NavListIcon
                        className={`icon ${sub.icon}`}
                        color={theme.dropdownIconColor}
                      />
                    </NavListIconWrapper>
                  )}
                  <SubNavListText>
                    <SubNavListHeading color={theme.dropdownNavItemColor}>
                      {sub.heading}
                    </SubNavListHeading>
                    {sub.desc && (
                      <SubNavListDesc color={theme.dropdownSubTextColor}>
                        {sub.desc}
                      </SubNavListDesc>
                    )}
                  </SubNavListText>
                </SubNavListItem>
              </Link>
              // Wrap end
            );
          }

          if (sub.type === "separator") {
            return <Separator key={i} color={theme.separatorColor} />;
          }

          if (sub.type === "subHeading") {
            return (
              <SubHeading key={i} color={theme.subHeadingColor}>
                {sub.heading}
              </SubHeading>
            );
          }

          if (sub.type === "seeAll") {
            return (
              <PageLinkWrapper key={i}>
                {/* Wrap with router link to navItem.href */}
                <PageLink color={theme.linkColor}>{navItem.heading}</PageLink>
              </PageLinkWrapper>
            );
          }

          throw new Error(`SubNav.js can't handle type "${sub.type}"`);
        })}
      </SubNavList>
    </SubNavWrapper>
  );
};

export default SubNav;
